import React, { FC } from 'react';
import { AlertIcon, CancelIcon, TickMarkIcon } from '../../../assets/icons';

type CustomModalProps = {
  text?: string | undefined | null;
  color?: string;
  showAlert?: boolean;
  setShowAlert?: React.Dispatch<React.SetStateAction<boolean>> | undefined;
  onClose?: () => void;
  isShowClose?: boolean;
};
const Alert: FC<CustomModalProps> = ({
  showAlert,
  setShowAlert,
  color,
  text,
  onClose,
  isShowClose = true,
}) => {
  return (
    <React.Fragment>
      {showAlert ? (
        <div
          className={
            'flex items-center justify-between text-white p-2 my-3 border-0 rounded relative bg-' +
            color
          }
        >
          <div className='flex gap-2 items-center'>
            {color === 'danger' ? (
              <AlertIcon className='!text-white' />
            ) : color === 'success' ? (
              <span className='bg-white rounded-[100%] border-white border-[2px]'>
                <TickMarkIcon />
              </span>
            ) : (
              <AlertIcon className='!text-white' />
            )}

            <span className='inline-block align-middle text-[14px]'>
              {text}
            </span>
          </div>
          <div
            onClick={() => {
              setShowAlert?.(false);
              onClose?.();
            }}
          >
            {isShowClose && (
              <CancelIcon className='!text-white cursor-pointer' />
            )}
          </div>
        </div>
      ) : null}
    </React.Fragment>
  );
};

export default Alert;
